module.exports = __webpack_public_path__ + "static/media/monteklas1.e08037d6.png";